import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { get } from 'lodash';
import { message } from 'antd';
import * as types from './types';
import * as actions from './actions';
import * as api from '@api/mbrPolicy';

const displayError = (err) => {
  const error = get(err, 'response.data.message', 'Unknown Error');
  message.error(error);
}

function* init() {
  try {
    yield put(actions.toggleLoading(true));
    const resp = yield call(api.getPolicies);
    const { data } = resp;
    yield put(actions.setData({policies: data}));
  } catch (err) {
    displayError(err);
  } finally {
    yield put(actions.toggleLoading(false));
  }
}

const watchMap = {
  [types.INIT]: init,
}

function* watch() {
  for (const [type, func] of Object.entries(watchMap)) {
    yield takeLatest([type], func);
  }
}

export default [
  watch,
];
